<template>
  <v-dialog :value="showDialog"
    :retain-focus="false"
    persistent
    @click:outside="closeDialog"
    :content-class="contentClasses">
    <v-card>
      <v-card-text class="escalon-dialog-content justify-center">
        <annotation-color-picker
          :value="annotationColor"
          @input="updateColor($event)"/>
        <reset-slider
          :value="annotationOptions.lineWidth"
          :color="colorHex"
          @input="updateLineWidth($event)"
          :min="1"
          :max="10"
          :step="0.1"
          :defaultValue="5"
          name="Line Width"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import annotationColorPicker from "../../components/imageBrowser/controls/AnnotationColorPicker";
import imageAnnotationHelper from "../../components/mixins/ImageAnnotationHelper";
import resetSlider from "../../components/controls/ResetSlider";
import { mapGetters } from "vuex";

export default {
  name: "shapeOutlineDialog",
  components: { annotationColorPicker, resetSlider },
  mixins: [imageAnnotationHelper],
  computed: {
    ...mapGetters(["heightXs", "heightSm", "heightMd", "isShapeOutlineOpen", "sideBySideIsSynced", "sideBySideContext", "sideBySideLeftContext", "sideBySideRightContext"]),
    ...mapGetters({ "context": "shapeOutlineContext", "syncContext": "shapeOutlineSyncContext"}),
    showDialog() {
      return this.isShapeOutlineOpen;
    },
    contentClasses() {      
      var classes = "download-dialog ";
      if (this.sideBySideContext) {
        if (this.context == this.sideBySideLeftContext) classes += "shape-outline-left";
        else if (this.context == this.sideBySideRightContext) {
          if (this.heightXs || this.heightSm || this.heightMd) classes += "shape-outline-right-small";
          else classes += "shape-outline-right";
        }
        else classes += "invisible"
      }
      else {
        if (this.heightXs || this.heightSm || this.heightMd) classes += "shape-outline-small";
        else classes += "shape-outline-large";
      }
      return classes
    }
  },
  methods: {
    closeDialog() {
      this.$store.commit("setShapeOutlineContext", null);
      this.$store.commit("setShapeOutlineSyncContext", null);
    },
    updateColor(color) 
    {
      this.updateAnnotationColor(color);
      this.closeDialog();
    }
  }
};
</script>